import { Heading, Flex, Text } from '@dapperlabs/core-fe';

import { SupplyLabel } from './SupplyLabel';

interface Props {
  availableSupply?: number;
  packTitle: string;
  tier: string;
  totalPacks: number;
}

const formatTier = (tierValue: string): string => {
  return tierValue.replaceAll('_', ' ').toLowerCase();
};

export const PackHeading = ({
  tier,
  totalPacks,
  packTitle,
  availableSupply,
}: Props) => (
  <Flex justifyContent='space-between' direction='column'>
    <Flex direction='row'>
      <Text as='div' mb={2} color='gray.300' fontFamily='mono' fontSize='md'>
        <Text
          as='span'
          color='#8A94A6'
          fontFamily='heading'
          fontSize='lg'
          fontWeight={500}
          textTransform='capitalize'
        >
          {formatTier(tier)}
        </Text>
        <SupplyLabel
          availableSupply={availableSupply}
          totalPacks={totalPacks}
        />
      </Text>
    </Flex>

    <Heading
      as='h2'
      fontFamily='poster'
      fontSize='5xl'
      fontWeight='500'
      lineHeight={1}
    >
      {packTitle}
    </Heading>
  </Flex>
);
